import {
  addDays,
  differenceInWeeks,
  endOfYear,
  format,
  getMonth,
  isSameDay,
  isWeekend,
  isWithinInterval,
  startOfYear,
} from 'date-fns';

export const START_OF_YEAR = startOfYear(new Date());
export const START_OF_YEAR_FORMATTED = format(START_OF_YEAR, 'MM-dd-yyyy');

export const END_OF_YEAR = endOfYear(new Date());
export const END_OF_YEAR_FORMATTED = format(END_OF_YEAR, 'MM-dd-yyyy');

const NUM_OF_WEEKS_PER_YEAR = differenceInWeeks(END_OF_YEAR, START_OF_YEAR) + 1;

export const buildMonthCells2 = (startDate, endDate) => {
  const data = [];
  let currentDate = new Date(startDate);
  let idCounter = 1;
  const today = new Date();
  while (currentDate < endDate) {
    const id = `m${idCounter}`;
    let title = format(currentDate, 'MMM').toUpperCase();
    const start = new Date(currentDate);
    const end = addDays(new Date(currentDate), 7);
    const isTodayInThisWeek = isWithinInterval(today, {
      start,
      end,
    });
    // Check if start and end dates fall into different months
    if (getMonth(start) !== getMonth(end)) {
      title = `${format(start, 'MMM').toUpperCase()} - ${format(
        end,
        'MMM'
      ).toUpperCase()}`;
    }

    data.push({
      id,
      title,
      start,
      end,
      isQuarter: true,
      isTodayInThisWeek,
    });

    currentDate = addDays(currentDate, 7); // Move to next "cell"
    idCounter++;
  }

  return data;
};

export const buildMonthWeekCells3 = (startDate, numWeeks) => {
  const data = [];
  let currentDate = new Date(startDate);
  let idCounter = 1;
  const today = new Date();

  for (let i = 0; i < numWeeks; i++) {
    const id = `m${idCounter}`;
    const start = new Date(currentDate);

    for (let j = 0; j < 7; j++) {
      const currentDay = addDays(new Date(start), j);
      const isWeekendDay = isWeekend(currentDay);
      const isCurrentDay = isSameDay(currentDay, new Date());
      const isTodayInThisWeek = isWithinInterval(today, {
        start,
        end: addDays(new Date(start), 7),
      });
      data.push({
        id: `${id}-${j}`,
        title: format(currentDay, 'd'),
        start: addDays(new Date(start), j),
        end: addDays(new Date(start), j + 1),
        isWeekend: isWeekendDay,
        isLastDay: j === 6,
        isCurrentDay,
        isTodayInThisWeek,
      });
    }

    currentDate = addDays(currentDate, 7); // Move to next week
    idCounter++;
  }

  return data;
};

const cellsData = buildMonthCells2(START_OF_YEAR, END_OF_YEAR);
const weekDays = buildMonthWeekCells3(START_OF_YEAR, NUM_OF_WEEKS_PER_YEAR);

export const buildTimebar = () => [
  {
    id: 'time1',
    title: 'Weeks',
    cells: cellsData,
    style: {},
  },
  {
    id: 'time2',
    title: 'Days',
    cells: weekDays,
    useAsGrid: true,
    style: {},
  },
];

export const TIMEBAR = buildTimebar();
